import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUS from './locales/en-US/translation.json';
import zhCN from './locales/zh-CN/translation.json';

void i18n.use(initReactI18next).init({
  lng: 'zh-CN',
  fallbackLng: 'zh-CN',
  supportedLngs: ['zh-CN', 'en-US'],
  interpolation: { escapeValue: false },
  resources: {
    'zh-CN': { translation: zhCN },
    'en-US': { translation: enUS },
  },
});

export default i18n;
